export default "/images/vendor/flag-icon-css/flags/1x1/gd.svg?43662bddde0a9fad49d97c79e6b669e1";